// ABOUTME: Frontend logging utility for consistent error reporting and debugging
// ABOUTME: Provides structured logging that can be extended with error reporting services
interface LogLevel {
  ERROR: "error";
  WARN: "warn";
  INFO: "info";
  DEBUG: "debug";
}

class Logger {
  private isDevelopment = import.meta.env.DEV;

  private log(level: keyof LogLevel, _message: string, _data?: unknown) {
    if (this.isDevelopment) {
      // In development, use console methods for better DevTools integration
      switch (level) {
        case "ERROR":
          break;
        case "WARN":
          break;
        case "INFO":
          break;
        case "DEBUG":
          break;
      }
    }

    // In production, you could send logs to an error reporting service
    // if (level === 'ERROR') {
    //   sendToErrorReportingService(logEntry);
    // }
  }

  error(message: string, data?: unknown) {
    this.log("ERROR", message, data);
  }

  warn(message: string, data?: unknown) {
    this.log("WARN", message, data);
  }

  info(message: string, data?: unknown) {
    this.log("INFO", message, data);
  }

  debug(message: string, data?: unknown) {
    this.log("DEBUG", message, data);
  }
}

export const logger = new Logger();
export default logger;
